export default __webpack_public_path__ + "static/gs-2-target-0eb08c3f67e80019ec4308c727c6202e.jpg";